class UploadAdapter {
  constructor (loader) {
    // The file loader instance to use during the upload.
    this.loader = loader

    // URL where to send files.
    const pathAdm = window.location.pathname.split('/')
    this.url = window.location.origin + '/' + pathAdm[1] + '/upload'
  }

  // Starts the upload process.
  upload () {
    // Update the loader's progress.
    // server.onUploadProgress(data => {
    //   loader.uploadTotal = data.total
    //   loader.uploaded = data.uploaded
    // })

    // Return a promise that will be resolved when the file is uploaded.
    // return loader.file.then(file => server.upload(file))

    return new Promise((resolve, reject) => {
      this._initRequest()
      this._initListeners(resolve, reject)
      this._sendRequest()
    })
  }

  // Aborts the upload process.
  abort () {
    // Reject the promise returned from the upload() method.
    // server.abortUpload()

    if (this.xhr) {
      this.xhr.abort()
    }
  }

  // Example implementation using XMLHttpRequest.
  _initRequest () {
    const xhr = (this.xhr = new XMLHttpRequest())

    xhr.open("POST", this.url, true)
    xhr.responseType = "json"
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners (resolve, reject) {
    const xhr = this.xhr
    const loader = this.loader
    const genericErrorText = "Couldn't upload file:" + ` ${loader.file.name}.`

    xhr.addEventListener("error", () => reject(genericErrorText))
    xhr.addEventListener("abort", () => reject())
    xhr.addEventListener("load", () => {
      const response = xhr.response

      if (!response || response.error) {
        return reject(
          response && response.error ? response.error.message : genericErrorText
        )
      }

      // If the upload is successful, resolve the upload promise with an object containing
      // at least the "default" URL, pointing to the image on the server.
      resolve({
        default: response.url,
      })
    })

    if (xhr.upload) {
      xhr.upload.addEventListener("progress", evt => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total
          loader.uploaded = evt.loaded
        }
      })
    }
  }

  // Prepares the data and sends the request.
  _sendRequest () {
    this.loader.file.then(file => {
      const data = new FormData()

      data.append("upload", file)
      this.xhr.setRequestHeader(
        "X-CSRF-TOKEN",
        document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      )

      this.xhr.send(data)
    })
  }
}

export default UploadAdapter
